module.exports = __webpack_public_path__ + "media/images/image-news2-d43ce343.png";